// Типографика статьи в превью блока — ПОРТ CSS ПЛЕЕРА, а не рефа.
// Реф (`ArticlePreviewContent` в MobilePreviewFrame.tsx) красил статью цветами
// и шрифтом дизайн-системы курса, но статью читатель видит НЕ в рефе, а в
// academy-frontend (`.../InstructionBlock/ArticleContent.module.css` +
// `InstructionBlock.module.css`), и вёрстка там своя, фиксированная. Превью
// обязано показывать её, иначе автор сверяет вид с макетом, которого не будет.
//
// Приём тот же, что у выделений дизайн-блока (`highlightScopeStyles`): стили
// цепляются за ТЕГИ внутри уникального скоупа, потому что HTML статьи приходит
// от бека без классов. Скоуп одинарный — конкурент здесь только глобальное
// `h1..h6 { ... }` из `src/index.css` (0,0,1), а `.scope h2` весит 0,1,1 и
// выигрывает у него безусловно.
import { blockTheme } from '@teach/ui'

const a = blockTheme.article

/** Кегль/начертание заголовка статьи (плеер: `.heading` 28px/700/1.15). */
export const ARTICLE_TITLE_STYLE = {
  color: a.heading,
  fontSize: '28px',
  fontWeight: 700,
  lineHeight: 1.15,
} as const

export const articleScopeStyles = (scope: string): string => {
  const s = `.${scope}`
  return `
    ${s} { color: ${a.text}; font-size: 17px; line-height: 1.55; }
    ${s} h2 { margin: 20px 0 0; color: ${a.heading}; font-size: 22px; font-weight: 600; line-height: 1.25; }
    ${s} h3 { margin: 16px 0 0; color: ${a.heading}; font-size: 18px; font-weight: 600; line-height: 1.3; }
    ${s} p { margin: 16px 0 0; }
    ${s} p:first-child, ${s} h2 + p, ${s} h3 + p { margin-top: 12px; }
    ${s} strong { font-weight: 600; }
    ${s} em { font-style: italic; }
    ${s} u { text-decoration: underline; text-underline-offset: 2px; }
    ${s} mark { border-radius: 6px; background: ${a.markBg}; padding: 2px 6px; color: ${a.markText}; box-decoration-break: clone; -webkit-box-decoration-break: clone; }
    ${s} a { color: ${a.accent}; text-decoration: underline; }
    ${s} ul, ${s} ol { margin: 12px 0 0; padding-left: 22px; }
    ${s} ul { list-style: disc; }
    ${s} ol { list-style: decimal; }
    ${s} li { margin-top: 6px; }
    ${s} li > p { margin: 0; }
    ${s} img { display: block; max-width: 100%; height: auto; margin: 12px 0; border-radius: 8px; }
  `
}
